import { all, call, put, takeLatest, fork } from 'redux-saga/effects';
import {
  Creators as UseBiogasActions,
  Types as UseBiogasTypes,
} from 'store/ducks/UseBiogas';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getUseBiogas({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/biogas-uses`, {
      params: payload,
    });
    if (status === 200) {
      yield put(UseBiogasActions.getUseBiogasListSuccess(data));
    } else {
      Sentry.captureMessage('getUseBiogas failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });

      yield put(UseBiogasActions.getUseBiogasListFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(UseBiogasActions.getUseBiogasListFail());
  }
}

function* deleteUseBiogas({ payload }) {
  try {
    const { status } = yield call(api.delete, `/biogas-uses/${payload}`);
    if (status === 200) {
      yield put(UseBiogasActions.deleteUseBiogasSuccess());
    } else {

      Sentry.captureMessage('deleteUseBiogas failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });

      yield put(UseBiogasActions.deleteUseBiogasFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(UseBiogasActions.deleteUseBiogasFail());
  }
}

function* createUseBiogas({ payload }) {
  try {
    const { status } = yield call(api.post, '/biogas-uses', payload);
    if (status === 200) {
      yield put(UseBiogasActions.createUseBiogasSuccess());
    } else {

      Sentry.captureMessage('createUseBiogas failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });

      yield put(UseBiogasActions.createUseBiogasFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(UseBiogasActions.createUseBiogasFail());
  }
}

function* getIdUseBiogas({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/biogas-uses/${payload}`);
    if (status === 200) {
      yield put(UseBiogasActions.getIdUseBiogasSuccess(data));
    } else {

      Sentry.captureMessage('getIdUseBiogas failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });

      yield put(UseBiogasActions.getIdUseBiogasFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(UseBiogasActions.getIdUseBiogasFail());
  }
}

function* updateUseBiogas({ payload }) {
  try {
    const { status } = yield call(
      api.put,
      `/biogas-uses/${payload.id}`,
      payload.data
    );
    if (status === 200) {
      yield put(UseBiogasActions.updateUseBiogasSuccess());
    } else {

      Sentry.captureMessage('updateUseBiogas failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });

      yield put(UseBiogasActions.updateUseBiogasFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(UseBiogasActions.updateUseBiogasFail());
  }
}

function* getUseBiogasWatcher() {
  yield takeLatest(UseBiogasTypes.GET_USE_BIOGAS_LIST_REQUEST, getUseBiogas);
}

function* deleteUseBiogasWatcher() {
  yield takeLatest(UseBiogasTypes.DELETE_USE_BIOGAS_REQUEST, deleteUseBiogas);
}

function* createUseBiogasWatcher() {
  yield takeLatest(UseBiogasTypes.CREATE_USE_BIOGAS_REQUEST, createUseBiogas);
}

function* getIdUseBiogasWatcher() {
  yield takeLatest(UseBiogasTypes.GET_ID_USE_BIOGAS_REQUEST, getIdUseBiogas);
}

function* updateUseBiogasWatcher() {
  yield takeLatest(UseBiogasTypes.UPDATE_USE_BIOGAS_REQUEST, updateUseBiogas);
}

export default function* rootSaga() {
  yield all([
    fork(getUseBiogasWatcher),
    fork(deleteUseBiogasWatcher),
    fork(createUseBiogasWatcher),
    fork(getIdUseBiogasWatcher),
    fork(updateUseBiogasWatcher),
  ]);
}
